import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";
import {
  connectionString,
  hostComponent,
  IMAP_PASSWORD_PLACEHOLDER,
  portComponent,
  tlsComponent,
} from "./shared";

export const imap = defineConnector({
  identifier: "imap",
  name: "IMAP",
  tagLine: "Read email over IMAP",
  logo,
  tags: ["communication"],
  protocol: "imap",
  connectionTest: { protocol: "imap", connectionString },
  defaultUrlPattern: () => "",
  customizeStepHandledInline: true,
  auth: customAuth("imap"),
  steps: [
    {
      title: "Enter your IMAP connection",
      items: [
        {
          kind: "input",
          label: "Name",
          required: true,
          defaultValue: "IMAP",
          target: { kind: "connectedApp", field: "name" },
        },
        {
          kind: "input",
          label: "Host",
          required: true,
          placeholder: "imap.example.com",
          target: { kind: "configuration", field: "host" },
        },
        {
          kind: "input",
          label: "Port",
          required: true,
          defaultValue: "993",
          target: { kind: "configuration", field: "port" },
        },
        {
          kind: "input",
          label: "Username",
          required: true,
          placeholder: "you@example.com",
          target: { kind: "configuration", field: "username" },
        },
        {
          kind: "input",
          label: "Password",
          required: true,
          target: { kind: "secrets", field: "password" },
        },
        {
          kind: "select",
          label: "TLS",
          required: true,
          defaultValue: "implicit",
          target: { kind: "configuration", field: "tls" },
          options: [
            { value: "implicit", label: "Implicit TLS (IMAPS, port 993)" },
            { value: "starttls", label: "STARTTLS (port 143)" },
            { value: "off", label: "Disabled" },
          ],
        },
        {
          kind: "file",
          label: "CA certificate",
          accept: ".pem,.crt,.cer",
          helperText:
            "Upload a PEM CA certificate for private or self-signed IMAP servers.",
          target: { kind: "configuration", field: "tlsCaCertificate" },
          visibleWhen: [
            {
              target: { kind: "configuration", field: "tls" },
              notValue: "off",
            },
          ],
        },
      ],
    },
  ],
  publicEnvVars: ({ host, port, username, tls }) => ({
    IMAP_HOST: hostComponent(host),
    IMAP_PORT: portComponent(port),
    IMAP_USERNAME: username ?? "",
    IMAP_PASSWORD: IMAP_PASSWORD_PLACEHOLDER,
    IMAP_TLS: tlsComponent(tls),
  }),
  usageHint: () =>
    "Read IMAP_HOST, IMAP_PORT, IMAP_USERNAME, and IMAP_PASSWORD from the environment to connect. IMAP_TLS is one of 'implicit' (TLS from the first byte, port 993), 'starttls' (upgrade in-band after the greeting, port 143), or 'off' (plaintext).",
});
